/**
 * @fileoverview GET handler for the "/:app_group_id/canvas_brief/:canvas_id" endpoint
 */
import fetch from "@lib/fetch";

import { isGetBriefResult } from "../briefShared";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { canvasBrief } from "./constants";
import type { GetCanvasBriefProps, GetCanvasBriefResult } from "./types";

export const getCanvasBrief = reactQueryFetcherAdapter(
  canvasBrief,
  (signal: AbortSignal, { appGroupId, canvasId }: GetCanvasBriefProps): Promise<GetCanvasBriefResult> => {
    return fetch(
      `/${appGroupId}/canvas_brief/${canvasId}`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetBriefResult
);
